// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsSetEmailKillSwitchBody = {
  isEnabled: boolean;
};

export type typeNotificationSettingsSetEmailKillSwitchOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isEmailKillSwitchOn: boolean };
};

export type typeNotificationSettingsSetEmailKillSwitchOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetEmailKillSwitchOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetEmailKillSwitchOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsSetEmailKillSwitchBody = {
  type: "object",
  properties: { isEnabled: { type: "boolean" } },
  required: ["isEnabled"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsSetEmailKillSwitch(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(
      schemaNotificationSettingsSetEmailKillSwitchBody,
    );
  }

  return async function postNotificationSettingsSetEmailKillSwitch(
    payload: typeNotificationSettingsSetEmailKillSwitchBody,
  ): Promise<
    | typeNotificationSettingsSetEmailKillSwitchOutput200
    | typeNotificationSettingsSetEmailKillSwitchOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsSetEmailKillSwitch" failed before calling the network. #f0eb39dc5913`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#f0eb39dc5913" },
        },
        data: null,
      } as typeNotificationSettingsSetEmailKillSwitchOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/set-email-kill-switch`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsSetEmailKillSwitchOutput200
      | typeNotificationSettingsSetEmailKillSwitchOutput400;
  };
}
